import apiWrapper from "Helpers/apiWrapper";
import { encodeParams, evalCondition } from "mailup-react-helpers";

const endpoints = ((baseURL) => {
	return {
		getAllLiquidProfileFilters: (idList) =>
			`${baseURL}/api/list/${encodeURIComponent(idList)}/liquidprofilefilters`,
		// filters
		getListOfFilters: (idList) =>
			`${baseURL}/api/list/${encodeURIComponent(idList)}/filters`,
		// categories
		getListOfCategories: (params) =>
			`${baseURL}/api/categories?${encodeParams(params)}`,
		// categories
		getFilter: (idfilter) =>
			`${baseURL}/api/filters/${encodeURIComponent(idfilter)}`,
	};
})(process.env.BEFILTERS_URL);

/**
 *
 * @param {number} idList ID of list
 * @param {Object} params
 * @param {number} params.pageSize The page size
 * @param {number} params.pageNumber The page number
 * @param {string} params.orderBy The column to order the result
 * @param {boolean} params.orderDescending Set true to order descending; otherwise ascending
 * @param {string} params.search Search filters by name
 * @param {Array(number)} params.categories Search filters by categories. [0] means searching filter without any category
 * @param {boolean} params.hidden Search filters by hidden status
 * @param {Array('Anagraphic'|'Activity'|'Device'|'Geolocation'|'Engagement'|'MultiType')} params.types Search filters by types
 *
 *
 */
export const beFiltersGetListOfFilters = (idList, params) => {
	const url = endpoints.getListOfFilters(idList);
	return apiWrapper({
		method: "post",
		url,
		data: JSON.stringify(params),
		headers: {
			"Content-Type": "application/json",
		},
	}).then(({ data }) => data);
};

/**
 *
 * @param {Object} params
 * @param {number} params.pageSize The page size
 * @param {number} params.pageNumber The page number
 * @param {string} params.orderBy The column to order the result
 * @param {boolean} params.orderDescending Set true to order descending; otherwise ascending
 * @param {string} params.name Search filters by name
 *
 */
export const beFiltersGetListOfCategories = (params) => {
	const url = endpoints.getListOfCategories(params);
	return apiWrapper({
		method: "get",
		url,
	}).then(({ data }) => data);
};
/**
 *
 * @param {number} idfilter filter id
 *
 */
export const beFiltersGetFilter = (idfilter) => {
	const url = endpoints.getFilter(idfilter);
	return apiWrapper({
		method: "get",
		url,
	}).then(({ data }) => data);
};

export const beFiltersGetAllLiquidProfileFilters = (idList) => {
	return apiWrapper({
		method: "get",
		url: endpoints.getAllLiquidProfileFilters(idList),
	}).then(({ data }) => data);
};

export const FILTER_TYPE_DEVICE = "Device";
export const FILTER_TYPE_ENGAGEMENT = "Engagement";

export const getAllAvailableFilterTypes = () => {
	const hasEngagementFilters = evalCondition("co:DELSTATS OR co:ENGAGEMENT");
	return [
		"Anagraphic",
		"Activity",
		"Device",
		"Geolocation",
		"MultiType",
		"Tracking",
		hasEngagementFilters ? "Engagement" : undefined,
	].filter((t) => t !== undefined);
};
